angular.module("Main").directive("kursWizard", wizzard);

function wizzard() {
    return {
        templateUrl: "./app/Main/controls/bookingWizard/kursWizard.html",
        restrict: "EA",
        controller: KursWizardController,
        controllerAs: "vm",
        scope: true,
        link: function (scope, element, attrs) {
            scope.active = scope.$eval(attrs.active);
            scope.cid = scope.$eval(attrs.cid);
            scope.hideLogin = !_.isNil(attrs.hideLogin);
        }
    };
}

KursWizardController.$inject = ["$scope", "$rootScope", "$location", "$uibModal", "$translate", "tmhDynamicLocale", "$localStorage", "LANGUAGES", "$stateParams", "$state", "SessionService", "BookingService"];

function KursWizardController($scope, $rootScope, $location, $uibModal, $translate, tmhDynamicLocale, $localStorage, LANGUAGES, $stateParams, $state, SessionService, BookingService) {
    var vm = this;
    vm.openedMenuBar = false;

    if (screen.width < 600) {
        vm.isMobilePhone = true;
    } else {
        vm.isMobilePhone = false;
    }

    init();
    loadLayoutConfiguration();
    getLocalStorageLoginData();
    loadKundenportalConfig();

    function getLocalStorageLoginData() {
        if (!_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username)) {
            vm.isLoggedIn = true;
            vm.username = $localStorage.user.username;

        }
    }

    vm.goto = function () {
        vm.openedMenuBar = false;
        var clubId = $scope.$parent.$resolve.$stateParams.cid;
        $state.go("kursplan", {cid: clubId, id: $stateParams.id});
    };

    vm.openMenuBar = function () {
        if (vm.openedMenuBar === false) {
            vm.openedMenuBar = true;
        } else {
            vm.openedMenuBar = false;
        }
    };

    var loginHandler = $rootScope.$on("login", function () {
        vm.isLoggedIn = true;
        vm.username = $localStorage.user.username;
    });

    vm.logout = function () {
        SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
        vm.isLoggedIn = false;
        vm.username = "";
        $localStorage.user = {};
        $rootScope.$emit("logout");
        $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()})
    };

    vm.loginModal = function () {
        let modalInstance = $uibModal.open({
            templateUrl: "app/Main/views/dialogs/login.html",
            controller: "LoginDialogController",
            controllerAs: "vm",
            backdrop: "static",
            keyboard: false
        });

        modalInstance.result.then(function (data) {
            if (!_.isNil(data)) {
                $localStorage.user = {};
                vm.isLoggedIn = true;
                let now = new Date;
                let hours = 6;
                //let minutes = 5;
                //let ttl = minutes * 60 * 1000
                let ttl = hours * 60 * 60 * 1000;
                //  vm.username = data.user.firstName + " " + data.user.lastName;
                $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                $localStorage.user.Firstname = data.user.Firstname;
                $localStorage.user.Lastname = data.user.Lastname;
                $localStorage.user.isMember = data.user.IsMember;
                $localStorage.user.memberNr = data.user.MemberNr;
                $localStorage.user.Email = data.user.Email;
                $localStorage.user.uid = data.user.uid;
                $localStorage.user.isPayPal = data.user.IsPaypal;
                $localStorage.user.isBonitaet = data.user.IsBonitaet;
                $localStorage.user.expiryTime = now.getTime() + ttl;
                $rootScope.$emit("login", vm.isLoggedIn);
            }
        });
    };

    vm.registerModal = function () {
        SessionService.clear('globals');

        DialogService.openRegisterDialog().then(function (isLoggedIn) {
            if (isLoggedIn) {
                vm.isLoggedIn = true;
                //let currentUser = SessionService.getUserData();
                // vm.username = currentUser.firstName + " " + currentUser.lastName;
                vm.username = $localStorage.username;
            }
        }).catch(function (error) {
        });
    };

    function getLocalStorageLanguage() {
        if (_.isNil($localStorage.currentLanguage))
            $localStorage.currentLanguage = _.first(LANGUAGES);

        return $localStorage.currentLanguage;
    }

    function init() {
        vm.isApp = SessionService.isApp();
        var userData = $localStorage.user;
        //var userData = SessionService.getUserData();
        if (!_.isNil(userData) && !_.isUndefined($localStorage.user.username)) {
            vm.isLoggedIn = true;
            //  vm.username = userData.firstName + " " + userData.lastName;
            vm.username = $localStorage.user.username;
        } else {
            vm.isLoggedIn = false;
            vm.username = "";
        }
        if (vm.isApp) {
            vm.currentLanguage = getLocalStorageLanguage();
            tmhDynamicLocale.set(vm.currentLanguage.lang);
            $translate.use(vm.currentLanguage.lang);
        }
        BookingService.loadLayoutConfiguration().then(function (data) {
            vm.registrierungZulassen = data.RegistrierungZulassen
        })
    }

    function loadLayoutConfiguration() {
        BookingService.loadLayoutConfiguration().then(function (data) {
            vm.layoutSettings = angular.fromJson(data.Layout);
        })
    }

    function loadKundenportalConfig() {
        BookingService.getKPConfig().then(function (data) {
            vm.kundenportalConfig = data;
        })
    }

    vm.goToKundenportal = function () {
        if (vm.kundenportalConfig.ZugangVomBuchungssystem) {
            $state.go('customer', {cid: SessionService.getAuthData()});
            $rootScope.$emit("login");
        }
    }

    vm.goToMeineTermine = function () {
        $state.go('meineterminekurs', {cid: SessionService.getAuthData(),id: SessionService.getAuthIdData(),});
        $rootScope.$emit("login");
    }

}